import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {token: String, url: String, consent: String, pagePath: String}

  connect() {
    this.elapsed = 0
    this.sent = false
    this.lastTick = performance.now()
    this.onConsent = event => {
      this.consentValue = event.detail
      this.elapsed = 0
      this.lastTick = performance.now()
      if (event.detail !== "allowed") {
        this.abort?.abort()
        try { sessionStorage.removeItem("analytics-previous-page") } catch {}
      }
    }
    this.onVisibility = () => { this.lastTick = performance.now() }
    window.addEventListener("analytics:consent", this.onConsent)
    document.addEventListener("visibilitychange", this.onVisibility)
    this.timer = setInterval(() => this.tick(), 250)
  }

  tick() {
    const now = performance.now()
    const delta = Math.min(now - this.lastTick, 500)
    this.lastTick = now
    if (document.hidden || this.consentValue !== "allowed" || this.sent || this.sending) return
    this.elapsed += delta
    if (this.elapsed >= 3000) this.send()
  }

  async send() {
    this.sending = true
    this.abort = new AbortController()
    try {
      const response = await fetch(this.urlValue, {
        method: "POST", signal: this.abort.signal, headers: {"Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content || ""},
        body: JSON.stringify({token: this.tokenValue, visible: !document.hidden, active_seconds: this.elapsed / 1000, ...this.referrer()})
      })
      if (response.ok || response.status === 422) {
        this.sent = true
        this.element.dataset.analyticsRecorded = String(response.ok)
        if (response.ok && this.consentValue === "allowed") {
          try { sessionStorage.setItem("analytics-previous-page", this.pagePathValue) } catch {}
        }
      }
      else this.elapsed = 0
    } catch { this.elapsed = 0 }
    finally { this.sending = false }
  }

  referrer() {
    try {
      const previous = sessionStorage.getItem("analytics-previous-page")
      if (previous?.startsWith("/") && !previous.startsWith("//")) return {referrer_host: location.hostname, referrer_path: previous}
    } catch {}
    try {
      const url = new URL(document.referrer)
      if (!["http:", "https:"].includes(url.protocol)) return {}
      return {referrer_host: url.hostname, referrer_path: url.hostname === location.hostname ? url.pathname : undefined}
    } catch { return {} }
  }

  disconnect() {
    clearInterval(this.timer)
    this.abort?.abort()
    window.removeEventListener("analytics:consent", this.onConsent)
    document.removeEventListener("visibilitychange", this.onVisibility)
  }
}
